import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { equals, toUpper } from "ramda";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import SortableItem from "./SortableItem";
import StatusBadge from "../StatusBadge";

const useStyles = makeStyles(theme => ({
  card: {
    height: 56,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.secondary.light,
    borderRadius: 10,
    gap: 10,
    paddingRight: 0,
    paddingLeft: 10,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },

  mediaType: {
    fontWeight: 700,
    fontSize: "1.2rem",
    textTransform: "uppercase",
  },

  statusLabel: {
    fontSize: "1.2rem",
    margin: 0,
  },

  thumbnail: {
    height: 40,
    width: 40,
    borderRadius: 8,
  },

  title: {
    fontSize: "1.2rem",
    textAlign: "left",
  },
}));

const statusBadgeLabel = {
  ACTIVE: "Live",
  INACTIVE: "Draft",
};

const ContentGroupCard = React.memo(function ContentGroupCard(props) {
  const { group, listeners } = props;
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.card)}
      container
      alignItems="center"
      justify="space-around"
      {...listeners}
    >
      <Grid item>
        <Box
          height={40}
          width={40}
          borderRadius={8}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Avatar
            className={classes.thumbnail}
            src={group.thumbnailUrl}
            alt={`${group.name} thumbnail`}
          />
        </Box>
      </Grid>

      <Grid item xs={6} md={7}>
        {group && (
          <Grid container justify="space-between" alignItems="center">
            <Typography className={classes.mediaType} noWrap>
              {group.mediaType}
            </Typography>

            {equals(toUpper(group.mediaType), "MODULE") && (
              <Grid item>
                <StatusBadge
                  size="xs"
                  status={group.status}
                  label={
                    <p className={classes.statusLabel}>
                      {statusBadgeLabel[group.status]}
                    </p>
                  }
                />
              </Grid>
            )}
          </Grid>
        )}
        <Typography className={classes.title} noWrap>
          {group.name}
        </Typography>
      </Grid>
    </Grid>
  );
});

const SortableContentGroupCard = props => {
  return (
    <SortableItem
      id={props.group.id}
      renderChild={({ ...sortableProps }) => (
        <ContentGroupCard {...sortableProps} group={props.group} />
      )}
    />
  );
};

export default SortableContentGroupCard;
